import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { LoadchargeComponent } from './loadcharge.component';
import { LoadchargeRoutingModule } from './loadcharge.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadchargeRoutingModule,
  ],
  exports: [
    LoadchargeComponent
  ],
  declarations: [
    LoadchargeComponent
  ],
})
export class LoadchargeModule { }
